
import React from 'react';
import Items from './components/Items'

function App() {
  return (
    <div className="mx-auto App">
      <Items />
    </div>
  );
}

export default App;